import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import './index.css'

const PageFooter = ({marginTop}) => {
  return (
    <div className='ddp-foo' style={{marginTop: `${marginTop || 4}rem` }}>
      <span className='ddp-foo-co'>
        <Link to='/about'>Dadopa {process.env.REACT_APP_VERSION}</Link>
      </span>
    </div>
  )
}

PageFooter.propTypes = {
  marginTop: PropTypes.number
}

export default PageFooter



// WEBPACK FOOTER //
// ./src/pages/Footer/index.js